<div class="parcel-status">
    <div class="status">
        <div class="parcel-status-icon">
            <app-parcel-status-icon [parcelStatusIdNo]="parcelStatusIdNo"></app-parcel-status-icon>
        </div>
        <div class="parcel-status-text">{{ parcelStatus }}</div>
    </div>
</div>